const JsP5 = () => {
    return (
        <div>
            <p>
                These are the projects I made when I was still learning JavaScript. I've been very
                inspired by <a href="https://www.youtube.com/c/TheCodingTrain">The Coding Train</a> on youtube,
                where I first saw the <code>p5.js</code> library.
                I feel like I learned the basic of the language quite well with those projects.
                <br />
                Here is an example of one of the projects: Ray Marching
                <br/>
                <img src="https://user-images.githubusercontent.com/59799831/174346459-17c6e109-01f5-4ff0-9999-1883d5001072.gif"></img>
            </p>
        </div>
    )
}

export default JsP5;